/* eslint-disable react/prop-types */
import React from 'react'

import {
    bottomZoneAverage,
    topZoneAverage,
    plateWidthFt,
} from 'bam-node-baseball-savant/constants/zone.ts'
import StrikeZoneDumb from './Dumb.tsx'
import type { ChartOptions } from '../../../schema/types.ts'

type StrikeZoneGenericProps = {
    xScale: d3.ScaleLinear<number, number>
    yScale: d3.ScaleLinear<number, number>
    chartOptions: ChartOptions
}

export default function StrikeZoneGeneric({
    xScale,
    yScale,
    chartOptions,
}: StrikeZoneGenericProps) {
    const styles = {
        strokeOpacity: chartOptions.strikeZoneBorderOpacity,
        fillOpacity: chartOptions.strikeZoneFillOpacity,
    }
    return (
        <StrikeZoneDumb
            xScale={xScale}
            yScale={yScale}
            szTop={topZoneAverage}
            szBot={bottomZoneAverage}
            plateWidthFt={plateWidthFt}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...styles}
        />
    )
}
